import { Component, OnInit,Input } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router } from '@angular/router';
@Component({
  selector: 'app-bcappview',
  templateUrl: './bcappview.component.html',
  styleUrls: ['./bcappview.component.sass']
})
export class BcappviewComponent implements OnInit {
  @Input('a') application: string;
  @Input('c') component: string;
  @Input('appname') name: string;
  @Input('appid') id: string;
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  gotoTimline(){
   let url= "/timeline/"+ this.component+"-"+this.application+"-"+btoa(this.id) ;
    this.router.navigate([url]);
    /* if(this.isLogin){
      this.router.navigate(['/create/'+this.application]);
    }else{
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/create/'+this.application, 'navigateByUrl': false } });
    }*/
  } 
}
